import React from "react"
import FormFinancierBucket from "./Form"
import ManageFinancierBucket from "./ManageItem"

export default function UpdateFinancierBucket({ params }) {

  return <ManageFinancierBucket
    params={ params }
    callback={ data =>
      <FormFinancierBucket financierBucket={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/Update.js